import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "./form/Button";
import { useTranslation } from "react-i18next";
import { postData } from "../services/api";

const DeletePopup = ({
  isOpen,
  setIsOpen = () => {},
  currentId,
  forClerify = '',
  getActionValue = () => {},
  message,
  setLoading = () => {},
  loading = false,
}) => {
  const { t } = useTranslation();
  const [info, setInfo] = useState([]);

  const closeModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const onSubmit = () => {
    setLoading(true);
    getActionValue({
      button_type: "delete",
      row_id: currentId,
      current_status: "",
    });
  };

  useEffect(() => {
    async function userData() {
      try {
        const result = await postData("user/info", {
          _id: currentId,
        });
        if (result.data) {
          setInfo(result.data);
        } else {
          console.log("info message", result.message);
        }
      } catch (error) {
        console.log("Error info catch", error.message);
      }
    }
    if (forClerify && forClerify === 'user-delete') {
      userData();
    }
  }, [forClerify, currentId]);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className={`w-full ${info.length > 0 ? 'max-w-md' : 'max-w-xs'} transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}>
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 text-center"
                >
                  {t("delete_record")}
                </Dialog.Title>
                <div className="absolute top-2 right-2 z-10">
                  <Button
                    buttonLabelClasses=""
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-times"}
                    buttonIconPosition={"left"}
                    buttonLabel={""}
                    buttonClasses={"!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"}
                    functions={closeModal}
                    buttonHasLink={false}
                  />
                </div>
                <div className="text-center my-3 text-slate-500">
                  {message ? (
                    message
                  ) : (
                    <>
                      You are trying to delete the record,
                      <br /> click &quot;Confirm&quot; below.
                    </>
                  )}
                </div>
                {info && info.length > 0 && (
                  <div className="rounded-2xl w-full py-5 px-5 overflow-hidden bg-dark-teal-100">
                    <h2 className="mb-2 text-sm font-semibold text-dark-teal-900">
                      The following details will be deleted along with the current record:
                    </h2>
                    <ul className="flex items-center gap-1 flex-wrap">
                      {info.map((itm, index) => (
                        <li className="h-8 rounded-md px-3 bg-dark-teal-300 text-dark-teal-900 flex items-center justify-center font-bold text-xs" key={index}>{itm?.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="flex gap-3 justify-center mt-4">
                  <Button
                    buttonIconPosition={"left"}
                    buttonIcon={"fa-regular fa-close"}
                    buttonLabel={"Cancel"}
                    functions={closeModal}
                    buttonClasses={
                      "!bg-dark-teal-500 !border-dark-teal-500 hover:!bg-dark-teal-500/80"
                    }
                  />
                  <Button
                    functions={onSubmit}
                    buttonIconPosition={"left"}
                    buttonIcon={"fa-regular fa-trash-can"}
                    buttonLabel={"Confirm"}
                    buttonClasses={
                      "!bg-rose-500 !border-rose-500 hover:!bg-rose-500/80"
                    }
                    buttonDisabled={loading}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default DeletePopup;
